<template>

    <ActionCombo :noClearable="noClearable" placeholder="type" :model="model"
        :rules="rules" v-model="dvalue" :items="items"
        show-custom-menu no-open no-create baseType="activitytype"
    >

        <template v-slot:customContextMenu>
            <ActionMenuItem v-if="dvalue" action="activitytype.open" @click="()=>onOpen(dvalue)" ></ActionMenuItem>
            <ActionMenuItem @click="()=>onCreate()" action="activitytype.create"></ActionMenuItem>
        </template>

</ActionCombo>

</template>

<script setup>
    import ActionMenuItem from '@controls/menu/ActionMenuItem.vue'

    // import ActivityTypeCombo from '@controls/combo/ActivityType'
    // <ActivityTypeCombo project|holiday|absence :model="model" :rules="model.rules.mandatory" v-model="model.id_type"></ActivityTypeCombo>

    const props = defineProps({
        rules: {
            type: [Array]
        },
        value: {
            type: [String, Number]
        },
        model: {
            type: [Object]
        },
        // project is the default.
        project: {
            type: [Boolean],
            default: false
        },
        holiday: {
            type: [Boolean],
            default: false
        },
        absence: {
            type: [Boolean],
            default: false
        },
        noClearable: {
            type: [Boolean],
            default: false
        }

    })
    
    import ActionCombo from '@controls/combo/ActionCombo'
    import {activitytype as list} from '@app/list';
    import {computed} from 'vue'
    import eventbus from '@app/eventbus';

    const emit = defineEmits(['input'])

    const dvalue = computed({
        get() {
            return props.value
        },
        set: function(v) {
            emit('input', v)
        }	
    })

    const items = computed({
        get() {
            if (props.holiday) {
                return list.holiday || []
            }
            if (props.absence) {
                return list.absence || []
            }
            return list.project ||[]
        },
    })

    function onOpen() {
        eventbus.dialog.open("activitytype", {id: dvalue.value})
    }
    async function onCreate() {
        var fnSelectCreated = (activityType) => {
            console.log('fnSelectCreated', activityType);
            dvalue.value = activityType.id;
        };
        var dlgOptions = await eventbus.dialog.create("activitytype")        
        console.log('dlgOptions', dlgOptions);
        dlgOptions.hookSaved(fnSelectCreated);

    }
</script>
